import Swal from "sweetalert2";
import axios from "../../axios";
import { setAlert } from "./alert";
import { ADD_STATE, DELETE_STATE, GET_ACTIVE_STATES, GET_STATES, UPDATE_STATE } from "../types";

export const addState = (data) => async (dispatch) => {
  try {
    const res = await axios.post("state/add", data);
    
    if (res.data.code === 1) {
      dispatch({ type: ADD_STATE, payload: res.data.data });
      Swal.fire({
        title: 'Success!',
        text: res.data.message || "State added successfully",
        icon: 'success',
      });
      dispatch(setAlert(res.data.message, "success"));
      return true;
    } else {
      const msg = res.data.message || "Failed to add state";
      dispatch(setAlert(msg, "warning"));
      Swal.fire({ title: 'Warning!', text: msg, icon: 'warning' });
      return false;
    }
  } catch (err) {
    const errorMsg = err?.response?.data?.message || err.message;
    dispatch(setAlert(errorMsg, "danger"));
    Swal.fire({ title: "Error!", text: errorMsg, icon: "error" });
    return false;
  }
};

export const updateState = (data) => async (dispatch) => {
  try {
    const updatedData = {
      id: data.id,
      ...(data.name && { name: data.name }),
      ...(data.coId && { coId: data.coId }),
      ...(data.code && { code: data.code }),
      ...(data.status !== undefined && { status: data.status }),
    };

    const res = await axios.post("state/update", updatedData);
    
    if (res.data.code === 1) {
      dispatch({ type: UPDATE_STATE, payload: res.data.data });
      Swal.fire({
        title: 'Success!',
        text: res.data.message || "State updated successfully",
        icon: 'success',
      });
      dispatch(setAlert(res.data.message, "success"));
      return true;
    } else {
      const msg = res.data.message || "Failed to update state";
      dispatch(setAlert(msg, "warning"));
      Swal.fire({ title: 'Warning!', text: msg, icon: 'warning' });
      return false;
    }
  } catch (err) {
    const errorMsg = err?.response?.data?.message || err.message;
    dispatch(setAlert(errorMsg, "danger"));
    Swal.fire({ title: "Error!", text: errorMsg, icon: "error" });
    return false;
  }
};

export const getStates = () => async (dispatch) => {
  try {
    const res = await axios.get("state/all");
    if (res.data.code === 1) {
      dispatch({ type: GET_STATES, payload: res.data.data });
    }
  } catch (err) {
    dispatch(setAlert(err.message, "danger"));
  }
};

export const getActiveStates = (formData) => async (dispatch) => {
  try {
    const updatedFormData = {
      id: formData.id,
      ...(formData.name && { name: formData.name }),
      ...(formData.status !== undefined && { status: formData.status }),
    };
    const res = await axios.post("state/update/status", updatedFormData);
    if (res.data.code === 1) {
      dispatch({ type: GET_ACTIVE_STATES, payload: res.data.data });
      Swal.fire({
        title: 'Success!',
        text: res.data.message,
        icon: 'success',
      });
    }
  } catch (err) {
    dispatch(setAlert(err.message, "danger"));
  }
};

export const deleteState = (id) => async (dispatch) => {
  try {
    if (!id) {
      dispatch(setAlert("Please select any record", "warning"));
      return false;
    }
    const res = await axios.post(`state/delete/${id}`);
    if (res.data.code === 1) {
      dispatch({ type: DELETE_STATE, payload: { id } });
      Swal.fire({
        title: 'Success!',
        text: res.data.message,
        icon: 'success',
      });
      dispatch(setAlert(res.data.message, "success"));
    } else {
      dispatch(setAlert(res.data.message, "warning"));
    }
  } catch (err) {
    dispatch(setAlert(err.message, "danger"));
  }
};
